'use client';

import { useState, useEffect } from 'react';

const BANNER_KEY = 'canopee_banner_v1';

export default function PromoBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(BANNER_KEY)) setVisible(true);
  }, []);

  if (!visible) return null;

  return (
    <div className="bg-forest text-cream-100 relative z-50">
      <div className="max-w-7xl mx-auto px-10 py-2.5 flex items-center justify-center">
        <p className="font-sans text-sm tracking-wide text-center">
          🌿 Offre de bienvenue &mdash;{' '}
          <strong className="font-medium">15% de réduction</strong> sur votre
          première séance
        </p>
      </div>
      <button
        onClick={() => {
          localStorage.setItem(BANNER_KEY, '1');
          setVisible(false);
        }}
        className="absolute right-4 top-1/2 -translate-y-1/2 text-cream-100/60 hover:text-cream-100 transition-colors text-xl leading-none cursor-pointer"
        aria-label="Fermer la bannière"
      >
        ×
      </button>
    </div>
  );
}
